import _ from 'lodash';
import moment from 'moment';

export function getActivePunches(punches) {
  const grouping = ['studio_name', 'classcard_name', 'expiration_date'];

  let activePunches = _.filter(punches, { expired: false });
  activePunches = _.map(activePunches, function (punch) {
    punch.expiration_date = moment(punch.expiration).format('YYYY-MM-DD');
    return punch;
  });

  const grouppedResult = activePunches.reduce((r, o) => {
    grouping
      .reduce(
        (group, key, i, { length }) =>
          (group[o[key]] = group[o[key]] || (i + 1 === length ? [] : {})),
        r
      )
      .push(o);

    return r;
  }, {});

  return _.flattenDeep(
    _.map(grouppedResult, studio => {
      return _.map(studio, classCard => {
        return _.map(classCard, (punches, expiration) => {
          return {
            studio_name: punches[0].studio_name,
            classcard_name: punches[0].classcard_name,
            classcard_id: punches[0].classcard_id,
            expiration: expiration,
            expiration_iso_date: punches[0].expiration,
            number_of_punches: punches.length,
            id: punches[0].id,
          };
        });
      });
    })
  );
}

export function getUsedPunches(punches) {
  return _.filter(punches, { expired: true });
}
